import config from '@/plugins/config.js'
import jwt_auth from '@/plugins/jwt-auth.js'
import emitter from '@/plugins/mitt.js'
import Vidle from 'v-idle-3'
import VueLazyload from 'vue-lazyload';
import VTooltipPlugin from './floating-vue.js'


export default {
  install: (app) => {
    app.use(Vidle);
    app.use(VTooltipPlugin);
    app.use(VueLazyload, {
      // Options for image compression, size, etc.
      // loading: require('@/assets/img/loading-mobile.svg'),
      attempt: 1,
      quality: 10,
      size: 50
    });

    app.config.globalProperties.$config = config
    app.config.globalProperties.$token = jwt_auth
    app.config.globalProperties.$emitter = emitter.emitter
  }
}